import {Button, notification, TableProps} from "antd";
import React from "react";
import {Operator} from "../../../../models/Operator";
import {FilterString} from "../../../Common/BasicComponents/filters/FilterString";
import {FilterDate} from "../../../Common/BasicComponents/filters/FilterDate";
import {BasicTable} from "../../../Common/BasicComponents/BasicTable";
import {AdminHttpService} from "../../../../services/Http/SearchTableService";
import {LoadOperatorsModal} from "../LoadOperatorsModal";
import {AuthService} from "../../../../services/AuthService";
import {useModal} from "../../../../utils/modals";
import {DownloadOutlined, UploadOutlined} from "@ant-design/icons";
import {OperatorsHttpService} from "../../../../services/Http/OperatorsHttpService";
import {parseFilenameFromHeader, saveFile} from "../../../../utils/files";
import {isNil} from "lodash";
import {FilterOperator} from "../../../Common/BasicComponents/filters/FilterOperator";
import {PageTitle} from "../../../Common/PageTitle/PageTitle";

export interface OperatorListPageProps {

}

export type AnyObject = Record<string, any>;

export function OperatorListPage<T extends AnyObject>(props:OperatorListPageProps) {
    const {
        isOpen: isLoadOperatorsOpen,
        open: openLoadOperatorsModal,
        close: closeLoadOperatorsModal
    } = useModal();

    const columns: TableProps<Operator>['columns'] = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id'
        },
        {
            title: 'Tipo di negozio',
            dataIndex: 'locationGroupCode',
            key: 'locationGroupCode'
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: 'Data di creazione',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (timestamp) => {
                const date = new Date(timestamp * 1000);
                return date.toLocaleDateString();
            },
        },
        {
            title: 'Codice del negozio',
            dataIndex: 'location',
            key: 'location'
        },
    ]

    const searchFilters =[
        <FilterOperator dataKey={"name"} placeholder={"Cognome Nome Negozio"}></FilterOperator>,
        <FilterDate dataKey={"createdAt"} placeholder={"Data di creazione"}></FilterDate>,
        <FilterString dataKey={"location"} placeholder={"Codice del negozio"}></FilterString>
    ]


    const exportOperators=async () => {
        const response = await OperatorsHttpService.exportAllOperators();
        console.log("response", response.status);
        if (response.status === 200) {
            const blob = response.data;
            const contentDisposition = response.headers["content-disposition"];
            const filename = isNil(contentDisposition) ? 'operators_export.xlsx' : parseFilenameFromHeader(contentDisposition);

            saveFile(blob,filename)

            notification['success']({
                message: 'Esportazione creata con successo'
            });
        } else {
            throw new Error('Errore durante la creazione dell\'esportazione');
        }
    }


    return <>
        <PageTitle title={"Carica operatori"}></PageTitle>

        <BasicTable<Operator>
            columns={columns}
            urlPath={AdminHttpService.URL_ADMIN_OPERATORS}
            filters={searchFilters}
        />



        {isLoadOperatorsOpen && <LoadOperatorsModal isOpen={isLoadOperatorsOpen} onOk={closeLoadOperatorsModal}
                                                    onCancel={closeLoadOperatorsModal}></LoadOperatorsModal>}

        <Button icon={<DownloadOutlined />} type={"primary"} key="download" style={{float: 'right', marginTop: '10px', marginLeft:'10px'}}
                onClick={() => {
                    AuthService.isAdmin() && exportOperators()
                }}>
            Esportare gli operatori
        </Button>
        <Button icon={<UploadOutlined />} key="import" style={{float: 'right', marginTop: '10px'}}
                onClick={() => {
                    AuthService.isAdmin() && openLoadOperatorsModal()
                }}>
            Importa file operatore
        </Button>
    </>

}